<template>
  <div class="settings-page">
    <template v-if="activeSettingName === 'sendFeedback'">
      <SendFeedback :click-handler="closeSettings" />
    </template>
    <template v-else-if="activeSettingName === 'editProfile'">
      <EditProfile :click-handler="closeSettings"></EditProfile>
    </template>
    <template v-else-if="activeSettingName === 'changePassword'">
      <ChangePassword :click-handler="closeSettings"></ChangePassword>
    </template>
    <template v-else-if="activeSettingName === 'donationPreferences'">
      <ChangeDonationPreferences :click-handler="closeSettings"></ChangeDonationPreferences>
    </template>
    <template v-else-if="activeSettingName === 'manipulateCards'">
      <DonationSource :click-handler="closeSettings"></DonationSource>
    </template>
    <template v-else-if="activeSettingName === 'bankAccount'">
      <BankAccount :click-handler="closeSettings" />
    </template>
    <template v-else-if="(activeSettingName === 'install' && !isInstalled)">
      <DeviceType :back="true"/>
    </template>
    <template v-else>
      <div class="page-content-container px30">
        <div class="page-content flex flex-col">
          <div class="flex-grow">
            <h2 class="page-title color-text font-bold text-28 text-text pt-8 tracking-tight leading-tight mb-10">
              <span class="text-primary">{{ $t("Settings") }}</span>
            </h2>
            <div class="mb-10" v-for="item in structure" :key="item.icon">
              <h3 class="flex items-center font-bold text-20 text-text mb-7">
                <FormIcons :icon="item.icon" />
                <span class="ml-2">{{ item.title }}</span>
              </h3>
              <div v-for="menu in item.menu" :key="menu.key" class="mb-6">
                <button type="button"
                  class="btn-link flex justify-between items-center w-full text-14 text-cause_text opacity-60 font-bold cursor-pointer"
                  @click="openSettings(menu.key)">
                  <span class="mr-2">{{ menu.title }}</span>
                  <FormIcons icon="chevron" />
                </button>
              </div>
            </div>
          </div>
          <div class="pt-8 pb-12">
            <Button type="button" classes="table mx-auto log-out-btn" :text="$t('Log Out')"
              :click-handler="logOut"></Button>
          </div>
        </div>
      </div>
      <Navigation :causeRedirectUrl="causeRedirectUrl" />
    </template>
    <ConfirmModal
      v-if="activeSettingName === 'install'"
      content="Looks like you already installed the app"
      btn-yes="OK"
      clas="w-2/5"
      btn-no=""
      @no="$setState('setConfirmModal', false)"
      @yes="$setState('setConfirmModal', false)"
    />
  </div>
</template>

<script>
import FormIcons from "../components/Icons/FormIcons";
import Button from "../components/UI/Button";
import SendFeedback from "../components/Settings/SendFeedback";
import EditProfile from "../components/Settings/EditProfile";
import ChangePassword from "../components/Settings/ChangePassword";
import ChangeDonationPreferences from "../components/Settings/ChangeDonationPreferences";
import DonationSource from "../components/Settings/DonationSource";
import mixins from "../config/mixins";
import BankAccount from "../components/Settings/BankAccount";
import DeviceType from "./DeviceType.vue";
import Navigation from "../components/Navigation/NewNavigation.vue";
import ConfirmModal from "../components/Modal/ConfirmModal.vue";

export default {
  name: "Settings",
  mixins: [mixins.helpers],
  components: {
    BankAccount,
    DonationSource,
    ChangeDonationPreferences,
    ChangePassword,
    EditProfile,
    Button,
    FormIcons,
    SendFeedback,
    DeviceType,
    Navigation,
    ConfirmModal
  },

  mounted () {
    if (
      this.$route.params.hasEmail !== undefined &&
      !this.$route.params.hasEmail
    ) {
      this.activeSettingName = "editProfile";
    } else {
      if (this.$user("has_avatar") === 0) {
        this.activeSettingName = "editProfile";
      }
    }

    if (!!this.$route.query.target) {
      if (this.$route.query.target === "card") {
        this.activeSettingName = "manipulateCards";
      } else if (this.$route.query.target === "bank") {
        this.activeSettingName = "bankAccount";
      }
    }
    if (this.$store.state.settingName) {
      this.activeSettingName = this.$store.state.settingName;
    }

    this.getUserNpos();
  },

  data() {
    return {
      causeRedirectUrl: "",
      activeSettingName: "settings",
      structure: [
        {
          icon: "user",
          title: this.$t("Account"),
          menu: [
            {
              title: this.$t("Edit Profile"),
              key: "editProfile"
            },
            {
              title: this.$t("Change password"),
              key: "changePassword"
            }
          ]
        },
        {
          icon: "heart",
          title: this.$t("Donation"),
          menu: [
            {
              title: this.$t("Change Donation Preferences"),
              key: "donationPreferences"
            }
          ]
        },
        {
          icon: "card",
          title: this.$t("Donation Source"),
          menu: [
            {
              title: this.$t("Cards: Add/Edit/Delete"),
              key: "manipulateCards"
            },
            {
              title: this.$t("Accounts: Add/Edit/Delete"),
              key: "bankAccount"
            }
          ]
        },
        {
          icon: "chat",
          title: this.$t("Help + FAQ"),
          menu: [
            {
              title: this.$t("Send Feedback"),
              key: "feedback"
            },
            {
              title: this.$t("FAQ"),
              key: "faq"
            },
            {
              title: this.$t("Save WebApp to Home Screen"),
              key: "install"
            }
          ]
        },
        {
          icon: "big-star",
          title: this.$t("More"),
          menu: [
            {
              title: this.$t("Register as Small Business"),
              key: "retailer-business"
            },
            {
              title: this.$t("Register as Beneficiary"),
              key: "non-profit-organization"
            }
          ]
        }
      ]
    };
  },

  computed: {
    isInstalled () {
      return window.matchMedia("(display-mode: standalone)").matches
    }
  },
  
  methods: {
    openSettings: function (setting) {
      if (setting == "feedback") {
        this.activeSettingName = "sendFeedback";
      } else if (setting == "faq") {
        window.open("https://www.jointhriveinitiative.org/faq", "_blank");
      } else if (setting == "retailer-business") {
        window.open(
          "https://app.jointhriveinitiative.org/sign-up-retailer",
          "_blank"
        );
      } else if (setting == "non-profit-organization") {
        window.open(
          "https://app.jointhriveinitiative.org/sign-up-npo",
          "_blank"
        );
      } else if (setting == "suggest-npo") {
        document.location.href =
          "mailto: info@jointhriveinitiative.org?subject=Suggest a Business or NPO | THRIVE Initiative";
      } else if (setting == "install") {
        this.$setState('setConfirmModal', this.isInstalled)
        this.activeSettingName = setting;
      } else {
        this.activeSettingName = setting;
      }
      this.$store.commit("setActiveSettings", this.activeSettingName);
    },
    closeSettings: function () {
      this.activeSettingName = "settings";
    },
    causeUrl: function (cause) {
      if (cause.length > 0) {
        this.causeRedirectUrl = `npos/${cause[0]["id"]}`;
      } else {
        this.causeRedirectUrl = "npos";
      }
    },
    getUserNpos: function () {
      this.$http.post("user/listnpo").then(res => {
        if (res && res.status !== undefined && res.status) {
          if (res.data.npo !== undefined) {
            this.causes = res.data.npo;
            this.causeUrl(this.causes);
            if (this.causes && this.causes.length > 0) {
              this.hasCauses = true;
            }
          }
        }
      });
    }
  },
  beforeDestroy() {
    this.$store.commit("setActiveSettings", null)
  },
  watch: {
    "$store.state.settingName": function (data) {
      this.activeSettingName = data;
    }
  }
};
</script>